<template>
    <div>
      <v-card>
    ID Zlecenia:  {{$route.params.idzlec}} <br>Data zlecenia {{items.data_zlecenia}}
    Planowana data rozpoczęcia {{items.planowana_data_rozpoczecia}}<br>
    Planowana data zakończenia{{items.planowana_data_zakonczenia}}
      </v-card>
      <br>
       <v-card>
<h2>Nazwa zlecenia{{items.nazwa}}</h2>

<br>
<h3>Rodzaj instalacji</h3> {{items.rodzaj_instalacji}}
<h3>Rodzaj usługi</h3> {{items.rodzaj_uslugi}}
<h4>Kilometry: {{items.kilometry}}</h4>
<h4>Kilometry koszt: {{items.kilometry_koszt}}</h4>
<h4>Opis:</h4> 
<p>{{items.opis}}</p> 
       </v-card>
       <v-card>
<h2>Nazwa obiektu: {{obiekt.nazwa}}</h2>
<h4>{{obiekt.miejscowosc}}</h4>
<h4>{{obiekt.ulica}}</h4>
<h4>{{obiekt.numerdomulokalu}}</h4>
<h4>{{obiekt.osoba_kontaktowa}}</h4>
<h4>{{obiekt.telefon}}</h4>
       </v-card>
       <br>
<v-card>
<h2>Zleceniodawca</h2>
{{zleceniodawca.nazwa}}
<p>Miejscowość: {{zleceniodawca.miejscowosc}}</p>
<p>Kod pocztowy: {{zleceniodawca.kodpocztowy}}</p>
<p>Ulica: {{zleceniodawca.ulica}} {{zleceniodawca.nrdomulokalu}}</p>
</v-card>
<br>
        <v-btn color="indigo" to="/mz" dark>Powrót</v-btn><v-btn color="error" @click="zrezlizujZlecenie">Zrealizuj zlecenie</v-btn>
    </div>
</template>

<script>
import axios from 'axios';
export default {
      data() {
    return {
      items: [],
      errors: [],
      users:[],
      zleceniodawca:[],
      obiekt:[]
    }
  },
      created() {
      var token = localStorage.getItem('token')
      // var wz = this;
       axios.get(`/api/users?token=`+token)
    .then(response => {
      // JSON responses are automatically parsed.
       this.users = response.data
      //  console.log(token);
       
      // console.log(this.users.id);
      
    axios.get('/api/mojezlecenia/dane/'+this.$route.params.idzlec+'?token='+token)
    .then(response => {
      // JSON responses are automatically parsed.
   
        
     this.items = response.data
      // console.log(response.data);

       axios.get('/api/zleceniodawcy/'+this.items.zleceniodawca_id+'?token='+token)
    .then(response => {
      // JSON responses are automatically parsed.
   
        
      this.zleceniodawca = response.data
      //  console.log(response.data);
        
      
    })
    .catch(e => {
     this.errors.push(e)
      
    })
axios.get('/api/obiekty/'+this.items.obiekt_id+'?token='+token)
    .then(response => {
      // JSON responses are automatically parsed.
   
        
      this.obiekt = response.data
      //  console.log(this.obiekt);
        
      
    })
    .catch(e => {
     this.errors.push(e)
      // console.log(this.errors);
    })



      
    })
    .catch(e => {
      this.errors.push(e)
      
    })
 
    })
    .catch(e => {
      this.errors.push(e)
    })
  },
  methods: {
    zrezlizujZlecenie(){
        this.$router.push('/zrealizuj/'+this.$route.params.idzlec)
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/DaneZlecenia.vue